module.exports = __webpack_public_path__ + "img/Desk Stationary A28.2bf59f1a.jpg";